import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from 'axios';
import { Toggle, EyeSVG, SaveSVG, LeftChevron, RightChevron, EditIconSVG } from "../../../Icons/icons";
import { BASEURL } from "../../../../constants";
import CreateCourseModal from "../../../Teacher/CreateCourseModal";
import CourseCreator from "../CourseCreator/CourseCreator";

const Header = ({ setCurrentQuestionId, setQuestion, setQuestionsArray, question, currentQuestionId, setSidebarToggle, questionsArray, baseRoute, isDataSaved, setIsDataSaved, setShowSaveDataModal, showSaveDataModal, courseInfo, selectedChapterId,
    selectedTestId, handleSaveCourse, slidesArray, setCurrentSlideId, setCurrentSlideData, currentSlideId, autoSaveQuestion, setCourseInfo, sidebarData,
    setSidebarData, setSelectedChapterId,
    setSelectedTestId,
    setSelectedTopicId,
    selectedTopicId, setImagesArray, validateQuestion, autoSaveSlide, fetchSubTopicData, setSlidesArray,nextSlide,previousSlide }) => {
    console.log(sidebarData, " side bar data inside header");

    const navigate = useNavigate();
    const { courseId } = useParams();
    const [isHovering, setIsHovering] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [id, setId] = useState(null);
    //slidesArray//setCurrentSlideId//setCurrentSlideData//currentSlideId

    // function nextSlide() {
    //     if (slidesArray.length === 0) {
    //         console.log("No slides available.");
    //         return;
    //     }

    //     const currentSlideIndex = slidesArray.findIndex(slide => slide.id === currentSlideId);

    //     // Check if the next slide exists
    //     if (currentSlideIndex + 1 < slidesArray.length) {
    //         setCurrentSlideId(slidesArray[currentSlideIndex + 1].id);
    //         setCurrentSlideData(slidesArray[currentSlideIndex + 1]);
    //         return; // Exit after navigating to the next slide
    //     }

    //     // If no next slide, check the next chapter or topic
    //     const currentTopic = sidebarData.topics.find(topic => topic.id === selectedTopicId);
    //     if (!currentTopic) {
    //         console.error("Current topic not found.");
    //         return;
    //     }

    //     const currentChapterIndex = currentTopic.content.findIndex(chapter => chapter.id === selectedChapterId);
    //     if (currentChapterIndex === -1) {
    //         console.error("Current chapter not found.");
    //         return;
    //     }

    //     // Check if the next chapter exists in the current topic
    //     if (currentChapterIndex + 1 < currentTopic.content.length) {
    //         const nextChapter = currentTopic.content[currentChapterIndex + 1];

    //         if (nextChapter.type === "slide-group") {
    //             setSelectedChapterId(nextChapter.id);
    //             setSelectedTestId(null);
    //         } else if (nextChapter.type === "test") {
    //             setSelectedTestId(nextChapter.id);
    //             setSelectedChapterId(null);
    //         } else {
    //             setSelectedChapterId(null);
    //             setSelectedTestId(null);
    //         }

    //         return; // Exit after navigating to the next chapter
    //     }

    //     // If no next chapter, check the next topic
    //     const currentTopicIndex = sidebarData.topics.findIndex(topic => topic.id === selectedTopicId);
    //     if (currentTopicIndex + 1 < sidebarData.topics.length) {
    //         const nextTopic = sidebarData.topics[currentTopicIndex + 1];
    //         setSelectedTopicId(nextTopic.id); // Update the selected topic ID

    //         // Set the first chapter of the next topic
    //         if (nextTopic.content?.length > 0) {
    //             const firstChapter = nextTopic.content[0];

    //             if (firstChapter.type === "slide-group") {
    //                 setSelectedChapterId(firstChapter.id);
    //                 setSelectedTestId(null);
    //             } else if (firstChapter.type === "test") {
    //                 setSelectedTestId(firstChapter.id);
    //                 setSelectedChapterId(null);
    //             } else {
    //                 setSelectedChapterId(null);
    //                 setSelectedTestId(null);
    //             }
    //         }
    //         return; // Exit after navigating to the next topic
    //     }

    //     // No more slides, chapters, or topics
    //     console.log("No more slides, chapters, or topics to navigate to.");
    // }


    // function previousSlide() {
    //     if (slidesArray.length === 0) {
    //         console.log("No slides available.");
    //         return;
    //     }

    //     const currentSlideIndex = slidesArray.findIndex(slide => slide.id === currentSlideId);

    //     // Check if the previous slide exists
    //     if (currentSlideIndex > 0) {
    //         setCurrentSlideId(slidesArray[currentSlideIndex - 1].id);
    //         setCurrentSlideData(slidesArray[currentSlideIndex - 1]);
    //         return; // Exit after navigating to the previous slide
    //     }

    //     // If no previous slide, check the previous chapter or topic
    //     const currentTopic = sidebarData.topics.find(topic => topic.id === selectedTopicId);
    //     if (!currentTopic) {
    //         console.error("Current topic not found.");
    //         return;
    //     }

    //     const currentChapterIndex = currentTopic.content.findIndex(chapter => chapter.id === selectedChapterId);
    //     if (currentChapterIndex === -1) {
    //         console.error("Current chapter not found.");
    //         return;
    //     }

    //     // Check if the previous chapter exists in the current topic
    //     if (currentChapterIndex > 0) {
    //         const previousChapter = currentTopic.content[currentChapterIndex - 1];
    //         if (previousChapter.type === "slide-group") {
    //             setSelectedChapterId(previousChapter.id); // Update the selected chapter ID
    //             setSelectedTestId(null);
    //         } else if (previousChapter.type === "test") {
    //             setSelectedTestId(previousChapter.id);
    //             setSelectedChapterId(null);
    //         } else {
    //             setSelectedChapterId(null);
    //             setSelectedTestId(null);
    //         }

    //         // Trigger the API call to fetch slide data for the previous chapter
    //         // fetchSubTopicData(previousChapter.id).then((newSlidesArray) => {
    //         //     if (newSlidesArray.length > 0) {
    //         //         setSlidesArray(newSlidesArray); // Update the slides array
    //         //         setCurrentSlideId(newSlidesArray[newSlidesArray.length - 1].id); // Set the last slide as the current slide
    //         //         setCurrentSlideData(newSlidesArray[newSlidesArray.length - 1]); // Set the last slide's data
    //         //     } else {
    //         //         console.log("No slides found for the previous chapter.");
    //         //     }
    //         // });
    //         return; // Exit after navigating to the previous chapter
    //     }

    //     // If no previous chapter, check the previous topic
    //     const currentTopicIndex = sidebarData.topics.findIndex(topic => topic.id === selectedTopicId);
    //     if (currentTopicIndex > 0) {
    //         const previousTopic = sidebarData.topics[currentTopicIndex - 1];
    //         setSelectedTopicId(previousTopic.id); // Update the selected topic ID

    //         // Set the last chapter of the previous topic
    //         if (previousTopic.content?.length > 0) {
    //             const lastChapter = previousTopic.content[previousTopic.content.length - 1];
    //             if (lastChapter.type === "slide-group") {
    //                 setSelectedChapterId(lastChapter.id); // Update the selected chapter ID
    //                 setSelectedTestId(null);
    //             } else if (lastChapter.type === "test") {
    //                 setSelectedTestId(lastChapter.id);
    //                 setSelectedChapterId(null);
    //             } else {
    //                 setSelectedChapterId(null);
    //                 setSelectedTestId(null);
    //             }

    //             // Trigger the API call to fetch slide data for the last chapter of the previous topic
    //             // fetchSubTopicData(lastChapter.id).then((newSlidesArray) => {
    //             //     if (newSlidesArray.length > 0) {
    //             //         setSlidesArray(newSlidesArray); // Update the slides array
    //             //         setCurrentSlideId(newSlidesArray[newSlidesArray.length - 1].id); // Set the last slide as the current slide
    //             //         setCurrentSlideData(newSlidesArray[newSlidesArray.length - 1]); // Set the last slide's data
    //             //     } else {
    //             //         console.log("No slides found for the last chapter of the previous topic.");
    //             //     }
    //             // });
    //         }
    //         return; // Exit after navigating to the previous topic
    //     }

    //     // No more slides, chapters, or topics
    //     console.log("No more slides, chapters, or topics to navigate to.");
    // }

    const disableStyle = {
        pointerEvents: "none",
        color: "grey"
    }

    // function disableNext() {
    //     if (currentSlideId === slidesArray[slidesArray.length - 1].id) return disableStyle;
    //     return {}
    // }

    // function disablePrevious() {
    //     if (currentSlideId === slidesArray[0].id) return disableStyle;
    //     return {}
    // }


    // function disablePreviousQuestion() {
    //     if (questionsArray[0].id === currentQuestionId) {
    //         return disableStyle;
    //     }
    // }

    // function disableNextQuestion() {
    //     if (questionsArray[questionsArray.length - 1].id === currentQuestionId) {
    //         return disableStyle
    //     }
    // }

    // function previousQuestion() {
    //     if (questionsArray.length === 0) {
    //         console.log("No questions available.");
    //         return;
    //     }


    //     // Save the current question before navigating
    //     autoSaveQuestion().then(() => {
    //         // Update the questions array
    //         setQuestionsArray((questionArray) =>
    //             questionArray.map((q) =>
    //                 q.id === currentQuestionId ? { ...question } : q
    //             )
    //         );

    //         // Find the index of the current question
    //         const currentQuestionIndex = questionsArray.findIndex(q => q.id === currentQuestionId);

    //         if (currentQuestionIndex > 0) {
    //             // Move to the previous question
    //             const previousQuestion = questionsArray[currentQuestionIndex - 1];

    //             setQuestion(previousQuestion);
    //             setCurrentQuestionId(previousQuestion.id);
    //             return;
    //         }

    //         // If no previous question, check the previous chapter or topic
    //         const currentTopic = sidebarData.topics.find(topic => topic.id === selectedTopicId);
    //         if (!currentTopic) {
    //             console.error("Current topic not found.");
    //             return;
    //         }

    //         const currentChapterIndex = currentTopic.content.findIndex(chapter => chapter.id === selectedTestId);
    //         if (currentChapterIndex === -1) {
    //             console.error("Current chapter not found.");
    //             return;
    //         }

    //         // Move to the previous chapter if available
    //         if (currentChapterIndex > 0) {
    //             const previousChapter = currentTopic.content[currentChapterIndex - 1];
    //             if (previousChapter.type === "test") {
    //                 setSelectedTestId(previousChapter.id);
    //                 setSelectedChapterId(null);

    //             } else {
    //                 setSelectedTestId(null);
    //                 setSelectedChapterId(previousChapter.id);
    //                 const lastquestion = slidesArray[slidesArray.length - 1]
    //                 setCurrentSlideId(previousChapter[previousChapter.length - 1].id)
    //                 console.log(previousChapter[previousChapter.length - 1].id);



    //             }

    //             // Move to the last question of the previous chapter
    //             const previousChapterQuestions = previousChapter.questions || [];
    //             if (previousChapterQuestions.length > 0) {
    //                 const lastQuestion = previousChapterQuestions[previousChapterQuestions.length - 1];
    //                 setQuestion(lastQuestion);
    //                 setCurrentQuestionId(lastQuestion.id);
    //             }
    //             return;
    //         }

    //         // If no previous chapter, check the previous topic
    //         const currentTopicIndex = sidebarData.topics.findIndex(topic => topic.id === selectedTopicId);
    //         if (currentTopicIndex > 0) {
    //             const previousTopic = sidebarData.topics[currentTopicIndex - 1];
    //             setSelectedTopicId(previousTopic.id);

    //             // Move to the last chapter in the previous topic
    //             if (previousTopic.content.length > 0) {
    //                 const lastChapter = previousTopic.content[previousTopic.content.length - 1];
    //                 if (lastChapter.type === "test") {
    //                     setSelectedTestId(lastChapter.id);
    //                     setSelectedChapterId(null);
    //                 } else {
    //                     setSelectedTestId(null);
    //                     setSelectedChapterId(lastChapter.id);
    //                 }

    //                 // Move to the last question of the last chapter
    //                 const lastChapterQuestions = lastChapter.questions || [];
    //                 if (lastChapterQuestions.length > 0) {
    //                     const lastQuestion = lastChapterQuestions[lastChapterQuestions.length - 1];
    //                     setQuestion(lastQuestion);
    //                     setCurrentQuestionId(lastQuestion.id);
    //                 }
    //             }
    //             return;
    //         }

    //         // No more questions, chapters, or topics
    //         console.log("No more previous questions, chapters, or topics to navigate to.");
    //     }).catch((error) => {
    //         console.error("Error during auto-save:", error);
    //     });
    // }


    // function nextQuestion() {
    //     if (questionsArray.length === 0) {
    //         console.log("No questions available.");
    //         return;
    //     }
    //     if (!validateQuestion()) {
    //         // If validation fails, return early
    //         return;
    //     }

    //     // Save the current question before navigating
    //     autoSaveQuestion().then(() => {
    //         // Update the questions array
    //         setQuestionsArray((questionArray) => {
    //             return questionArray.map((q) =>
    //                 q.id === currentQuestionId ? { ...question } : q
    //             );
    //         });

    //         // Find the index of the current question
    //         const currentQuestionIndex = questionsArray.findIndex(q => q.id === currentQuestionId);

    //         if (currentQuestionIndex !== -1 && currentQuestionIndex + 1 < questionsArray.length) {
    //             // Move to the next question
    //             const nextQuestion = questionsArray[currentQuestionIndex + 1];
    //             setQuestion(nextQuestion);
    //             setCurrentQuestionId(nextQuestion.id);
    //             return;
    //         }

    //         // If no next question, check the next chapter or topic
    //         const currentTopic = sidebarData.topics.find(topic => topic.id === selectedTopicId);
    //         if (!currentTopic) {
    //             console.error("Current topic not found.");
    //             return;
    //         }

    //         const currentChapterIndex = currentTopic.content.findIndex(chapter => chapter.id === selectedTestId);
    //         if (currentChapterIndex === -1) {
    //             console.error("Current chapter not found.");
    //             return;
    //         }

    //         // Move to the next chapter if available
    //         if (currentChapterIndex + 1 < currentTopic.content.length) {
    //             const nextChapter = currentTopic.content[currentChapterIndex + 1];
    //             if (nextChapter.type === "test") {
    //                 setSelectedTestId(nextChapter.id);
    //                 setSelectedChapterId(null);

    //             } else {
    //                 setSelectedTestId(null);
    //                 setSelectedChapterId(nextChapter.id);
    //                 console.log(currentSlideId, "current");

    //             }
    //             return;
    //         }

    //         // If no next chapter, check the next topic
    //         const currentTopicIndex = sidebarData.topics.findIndex(topic => topic.id === selectedTopicId);
    //         if (currentTopicIndex !== -1 && currentTopicIndex + 1 < sidebarData.topics.length) {
    //             const nextTopic = sidebarData.topics[currentTopicIndex + 1];
    //             setSelectedTopicId(nextTopic.id);

    //             // Move to the first chapter in the next topic
    //             if (nextTopic.content.length > 0) {
    //                 const firstChapter = nextTopic.content[0];
    //                 if (firstChapter.type === "test") {
    //                     setSelectedTestId(firstChapter.id);
    //                     setSelectedChapterId(null);
    //                 } else {
    //                     setSelectedTestId(null);
    //                     setSelectedChapterId(firstChapter.id);
    //                 }
    //             }
    //             return;
    //         }

    //         // No more questions, chapters, or topics
    //         console.log("No more questions, chapters, or topics to navigate to.");
    //     }).catch((error) => {
    //         console.error("Error during auto-save:", error);
    //     });
    // }



    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleOnEditCourse = async (id) => {
        if (id) {
            setId(id)
            setIsModalOpen(true)
        }

    }

    return (
        <>
            
            <CreateCourseModal isOpen={isModalOpen} onClose={handleCloseModal} id={id} setCourseInfo={setCourseInfo} />
            {
                showSaveDataModal && (
                    <div className="relative  z-30" aria-labelledby="modal-title" role="dialog" aria-modal="true">

                        <div className="fixed   inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

                        <div className="fixed h-full  inset-0 z-10 w-screen overflow-y-auto">
                            <div className="flex min-h-full h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">

                                <div style={{ minWidth: '20%' }} className="relative p-3 h-auto transform flex-col justify-evenly rounded-lg bg-white text-left shadow-xl transition-all my-8">

                                    <div className='flex w-full justify-center'>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-10">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                                        </svg>
                                    </div>
                                    <div className="flex justify-center py-2 px-3">
                                        <span className='font-bold'>Save changes</span>

                                    </div>
                                    <div className="flex justify-center py-2 px-3">
                                        <span className='text-xs text-gray-600'>Save your latest changes first!</span>

                                    </div>
                                    <div className="flex justify-around">
                                        <button className='px-3 py-1 border-2 border-gray-300 rounded-lg text-gray-500 text-xs' onClick={() => { setShowSaveDataModal(false) }}>Cancel</button>
                                        <button onClick={() => { handleSaveCourse(); setShowSaveDataModal(false) }} className='px-3 py-1 bg-slate-500 text-white rounded-lg text-xs'>Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
            {
                courseInfo && (
                    <div className="z-10 flex justify-between items-center px-6 py-2 bg-white"
                        style={{ boxShadow: "0px 2px 2px 0px rgba(20, 29, 34, 0.10)" }}
                    >
                        <div className="flex items-center">
                            <div className="cursor-pointer" onClick={() => {
                                setSidebarToggle((sidebarToggle) => {
                                    return !sidebarToggle;
                                })
                            }}>
                                <Toggle />
                            </div>
                            <div
                                className="flex flex-col py-0 px-4"
                                onMouseEnter={() => { setIsHovering(true); }}
                                onMouseLeave={() => { setIsHovering(false); }}
                            >
                                <div className="flex items-center">
                                    <span className="text-2xl font-bold">{courseInfo.course_name}</span>
                                    {isHovering && (
                                        <span onClick={() => handleOnEditCourse(courseId)} className="ml-2">
                                            <EditIconSVG />
                                        </span>
                                    )}
                                </div>
                                <span
                                    className="text-gray-500 text-xs truncate max-w-96 mt-1 2xl:text-lg"
                                    title={courseInfo.course_desc}
                                >
                                    {courseInfo.course_desc}
                                </span>
                            </div>

                        </div>
                        <div className="flex items-center gap-4">
                            {/* <i class="fa-solid fa-palette icon-medium bordered-icon"></i> */}
                            <button onClick={() => {
                                if (isDataSaved) {
                                    navigate(`/quick-preview/${courseId}`, {
                                        state: {
                                            selectedChapterId,
                                            currentSlideId,
                                            selectedTopicId,
                                            selectedTestId,
                                            currentQuestionId
                                        },
                                    });
                                } else {
                                    setShowSaveDataModal(true);
                                }

                            }} class="h-[40px] w-[40px] justify-center text-xs 2xl:text-base py-1 px-1 cursor-pointer bg-white border border-solid border-[#E0E0E0] flex items-center gap-2">
                                <EyeSVG />
                            </button>

                            <button class="flex gap-2 items-center justify-center text-xs 2xl:text-base py-2 px-3 bg-[#382F8A] text-white cursor-pointer h-[40px] hover:bg-[#1F1A4C]" onClick={() => { handleSaveCourse('normal') }}>
                                <SaveSVG />
                                Save
                            </button>
                            {/* <button class="text-xs py-1.5 px-2 rounded-md cursor-pointer bg-slate-800 text-gray-100 border border-solid border-slate-500 font-bold">Publish</button> */}
                            {/* <div className="shrink-0 h-8 w-[1.7px] bg-[#E0E0E0] rounded"></div> */}
                           
                            
                        </div>
                    </div>
                )
            }
        </>
    )
}

export default Header;